<template>
  <v-dialog fullscreen scrollable dark content-class="contract" v-model="contract">
    <div class="inside">
      <div class="close" @click="contract = false">
        <svg class="icon">
          <use xlink:href="../../assets/sprite.svg#close"></use>
        </svg>
      </div>
      <v-container>
        <div class="question" :class="{hide: isActivePhysical || isActiveJurist}">
          <div class="item d-flex justify-center">
            <div>
              <v-row>
                <v-col class="text-center">
                  <h1>Ваш юридический статус?</h1>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <div class="buttons pt-6" >
                    <v-btn outlined text @click="isActivePhysical = true">Физическое лицо</v-btn>
                    <v-btn outlined text @click="isActiveJurist = true">Юридическое лицо</v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="physicalForm justify-center" :class="{show: isActivePhysical}">
          <physicalForm v-model="isActivePhysical"/>
        </div>
        <div class="juristForm justify-center" :class="{show: isActiveJurist}">
          <juristForm v-model="isActiveJurist"/>
        </div>
      </v-container>
    </div>
  </v-dialog>
</template>

<script>
import physicalForm from './physicalForm.vue'
import juristForm from './juristForm.vue'
export default {
  props: {
    value: Boolean
  },
  components: {
    physicalForm,
    juristForm
  },
  watch : {
    value(newVal){
      this.contract = newVal
    },
    contract(newVal) {
      this.$emit('input', newVal)
    }
  },
  data: () => {
    return {
      contract: false,
      isActivePhysical: false,
      isActiveJurist: false
    }
  }
}
</script>



<style lang="scss">
  .contract {
    .inside {
      display: flex;
      height: 100%;
      h1 {
        color: #fff;
      }
      .close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 2%;
        svg {
          width: 1.6rem;
          height: 1.6rem;
          fill: #fff;
        }
      }
      .container {
        height: 100%;
        .question {
          height: 100%;
          &.hide {
            display: none;
          }
          .item {
            height: 100%;
            align-items: center;
            .buttons {
              button {
                margin: 0 1rem;
              }
              .theme--dark.v-btn.v-btn--outlined.v-btn--text {
                border-color: rgba(255, 255, 255, 0.62);
              }
            }
          }
        }
        .physicalForm, {
          display: none;
          height: 100%;
          &.show {
            display: flex;
            align-items: center;
          }
        }
        .juristForm {
          display: none;
          &.show {
            display: flex;
          }
        }
      }
    }
  }

</style>